module.exports = __webpack_public_path__ + "img/scene6.d6aa59e9.png";